const UTILITY_WORKFLOW_UI_STATE_STORAGE_KEY = 'utility-workflow-ui-state-v1';
const MAX_UTILITY_FORECAST_YEAR = 2050;
const MIN_MDHD_SIMULATION_END_YEAR = 2027;

function clampForecastEndYear(value, fallback = MAX_UTILITY_FORECAST_YEAR, minYear = 2026) {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return fallback;
  return Math.max(minYear, Math.min(MAX_UTILITY_FORECAST_YEAR, Math.round(numericValue)));
}

function canUseSessionStorage() {
  return typeof window !== 'undefined' && !!window.sessionStorage;
}

function getDefaultState() {
  return {
    workflow: {
      activeTab: 'passenger-ev',
      selectedVehicleCategories: null,
    },
    mdhdAdoptionTrend: {
      selectedUtility: '',
      selectedScenario: '',
      simulationEndYear: MAX_UTILITY_FORECAST_YEAR,
    },
    passengerAdoptionTrend: {
      startYear: 2026,
      endYear: MAX_UTILITY_FORECAST_YEAR,
      passengerCarPopulation: 1000000,
      curveInputMode: 'builtin',
    },
    passengerZctaAdoptionTrend: {},
  };
}

export function getUtilityWorkflowUiState() {
  const defaults = getDefaultState();
  if (!canUseSessionStorage()) return defaults;

  try {
    const raw = window.sessionStorage.getItem(UTILITY_WORKFLOW_UI_STATE_STORAGE_KEY);
    if (!raw) return defaults;
    const parsed = JSON.parse(raw);
    const nextState = {
      ...defaults,
      ...(parsed || {}),
      workflow: {
        ...defaults.workflow,
        ...((parsed || {}).workflow || {}),
      },
      mdhdAdoptionTrend: {
        ...defaults.mdhdAdoptionTrend,
        ...((parsed || {}).mdhdAdoptionTrend || {}),
      },
      passengerAdoptionTrend: {
        ...defaults.passengerAdoptionTrend,
        ...((parsed || {}).passengerAdoptionTrend || {}),
      },
      passengerZctaAdoptionTrend: {
        ...defaults.passengerZctaAdoptionTrend,
        ...((parsed || {}).passengerZctaAdoptionTrend || {}),
      },
    };
    nextState.passengerAdoptionTrend = {
      ...nextState.passengerAdoptionTrend,
      endYear: clampForecastEndYear(nextState.passengerAdoptionTrend?.endYear),
    };
    nextState.mdhdAdoptionTrend = {
      ...nextState.mdhdAdoptionTrend,
      simulationEndYear: clampForecastEndYear(
        nextState.mdhdAdoptionTrend?.simulationEndYear,
        MAX_UTILITY_FORECAST_YEAR,
        MIN_MDHD_SIMULATION_END_YEAR
      ),
    };
    nextState.passengerZctaAdoptionTrend = Object.fromEntries(
      Object.entries(nextState.passengerZctaAdoptionTrend || {}).map(([zcta, value]) => [
        zcta,
        {
          ...(value || {}),
          endYear: clampForecastEndYear(value?.endYear),
        },
      ])
    );
    return nextState;
  } catch {
    return defaults;
  }
}

export function updateUtilityWorkflowUiState(section, values) {
  if (!section || !canUseSessionStorage()) return;
  const current = getUtilityWorkflowUiState();
  const next = {
    ...current,
    [section]: {
      ...(current[section] || {}),
      ...(values || {}),
    },
  };
  window.sessionStorage.setItem(UTILITY_WORKFLOW_UI_STATE_STORAGE_KEY, JSON.stringify(next));
}
